<template>
  <el-dialog
    v-if="isShowDialog"
    title="选择组合商品"
    center
    top="5vh"
    :visible.sync="isShowDialog"
    append-to-body
    width="90%"
    :before-close="beforeclose"
  >
    <el-form
      :inline="true"
      ref="searchform"
      :model="formData"
      class="demo-form-inline"
      size="medium"
    >
      <el-form-item label="商品名称：" prop="productName">
        <el-input
          type="text"
          v-model="formData.productName"
          placeholder="请输入商品名称"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="商品编号：" prop="productIdList">
        <el-input
          type="text"
          v-model="formData.productIdList"
          placeholder=" 商品编号（多商品查询用英文逗号隔开）"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="搭配组合名称：" prop="name">
        <el-input
          type="text"
          v-model="formData.name"
          placeholder="请输入搭配组合名称"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="搭销组合ID：" prop="idList">
        <el-input
          type="text"
          v-model="formData.idList"
          placeholder="搭销组合ID（多商品查询用英文逗号隔开）"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="状态：" prop="saleStatus">
        <el-select
          v-model="formData.saleStatus"
          placeholder="全部状态"
          clearable
        >
          <el-option label="上架" :value="1"></el-option>
          <el-option label="下架" :value="2"></el-option>
          <el-option label="缺货" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="子商品名称：" prop="secondaryProductName">
        <el-input
          type="text"
          v-model="formData.secondaryProductName"
          placeholder="请输入子商品名称"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="子商品编号：" prop="secondaryProductIdList">
        <el-input
          type="text"
          v-model="formData.secondaryProductIdList"
          placeholder="多个子商品ID用英文逗号隔开"
          clearable
        ></el-input>
      </el-form-item>
      <span style="margin-left: 20px">
        <el-button type="primary" @click="search">查询</el-button>
        <el-button @click="resetForm">重置</el-button>
      </span>
    </el-form>
    <div>
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        @select="changeFun"
        @selection-change="handleSelectionChange"
        ref="multipleTable"
        row-key="id"
      >
        <el-table-column
          type="selection"
          width="55"
          :selectable="selected"
          reserve-selection
          align="center"
        ></el-table-column>
        <el-table-column
          prop="id"
          label="搭配组合ID"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="name"
          width="250"
          label="搭配组合名称"
          align="center"
        >
        </el-table-column>
        <el-table-column label="主商品" align="left" width="300">
          <template slot-scope="scope">
            <div
              v-for="(item, jndex) in scope.row.collocationProductList"
              :key="jndex"
            >
              <div v-if="jndex == 0">
                <p>编码：{{ item.productId }}</p>
                <p>名称：{{ item.productName }}</p>
                <p>
                  状态：<span v-if="item.saleStatus == 1">上架</span
                  ><span v-if="item.saleStatus == 2">下架</span
                  ><span v-if="item.saleStatus == 3">缺货</span>
                </p>
                <p>
                  药品类型：<span v-if="item.prescriptionType == 1">处方药</span
                  ><span v-if="item.prescriptionType == 2">非药品</span
                  ><span v-if="item.prescriptionType == 3">OTC</span>
                </p>
                <p>功效：{{ item.functionIndications }}</p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="子商品" align="left" width="300">
          <template slot-scope="scope">
            <div
              v-for="(item, jndex) in scope.row.collocationProductList"
              :key="jndex"
            >
              <div
                v-if="jndex != 0"
                style="background-color: antiquewhite; margin-bottom: 10px; padding: 5px;"
              >
                <p>编码：{{ item.productId }}</p>
                <p>名称：{{ item.productName }}</p>
                <p>
                  状态：<span v-if="item.saleStatus == 1">上架</span
                  ><span v-if="item.saleStatus == 2">下架</span
                  ><span v-if="item.saleStatus == 3">缺货</span>
                </p>
                <p>是否置顶：{{ item.isTop ? "是" : "否" }}</p>
                <p>
                  药品类型：<span v-if="item.prescriptionType == 1">处方药</span
                  ><span v-if="item.prescriptionType == 2">非药品</span
                  ><span v-if="item.prescriptionType == 3">OTC</span>
                </p>
                <p>功效：{{ item.functionIndications }}</p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="组合最低价和最低毛利率"
          align="left"
          width="200"
        >
          <template slot-scope="scope">
            <p>组合最低价：{{ scope.row.minCombinePrice }}</p>
            <p
              :style="
                scope.row.minGrossRate <= 0 ? 'color:green' : 'color:reds'
              "
            >
              组合最低毛利率：{{ (scope.row.minGrossRate * 100).toFixed(2) }}%
            </p>
          </template>
        </el-table-column>
        <el-table-column
          label="药师点评"
          prop="pharmacistEvaluation"
          align="left"
          width="300"
        >
        </el-table-column>
      </el-table>
    </div>
    <div class="coupon-clock-paging">
      <div>已选商品数量：{{ goods.length }}</div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="formData.page"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="formData.pageSize"
        layout="total,sizes, prev, pager, next, jumper"
        :total="total"
        background
      ></el-pagination>
    </div>
    <el-row type="flex" justify="center" style="margin-top: 30px">
      <el-button @click="beforeclose">取消</el-button>
      <el-button type="primary" @click="saveData" :loading="saveLoading"
        >确定</el-button
      >
    </el-row>
  </el-dialog>
</template>

<script>
import { queryComListDx } from "@/api/shop/selfpromotionManage";
import CategorySelect from "@/myviews/shoppMall/components/CategorySelect.vue"; //分类
import { getSpreadActivityCollocationList } from "@/api/shop/activitySet";
export default {
  name: "productListSelect",
  props: ["isShowDialog", "SelectedProductList", "canMultipleChoice"],
  components: {
    CategorySelect
  },
  data() {
    return {
      saveLoading: false,
      formData: {
        isQueryInActivityCollocation: true,
        channelCode: "SHOP",
        productName: "",
        productIdList: "",
        name: "",
        idList: "",
        saleStatus: "",
        secondaryProductIdList: "",
        secondaryProductName: "",
        page: 1,
        pageSize: 10
      },
      loading: false,
      channelSelects: [], // 渠道数据

      tableData: [], //表单数据
      total: 0, //总条数
      selectionData: [], //选中数据
      selectedIds: []
    };
  },
  watch: {
    isShowDialog: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.getData();
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    goods() {
      const SelectedProductList = this.SelectedProductList || [];
      const selectedIds = SelectedProductList.map(item => {
        return {
          id: item.collocationId
        };
      });
      const parmas = this.selectionData.concat(selectedIds || []);
      const uniqueArray = this.uniqueById(parmas, "id");
      return uniqueArray;
    }
  },
  methods: {
    uniqueById(array, property) {
      return array.filter(
        (obj, index, self) =>
          index === self.findIndex(o => o[property] === obj[property])
      );
    },
    getData() {
      let data = {
        ...this.formData
      };
      this.loading = true;
      const { productIdList, idList, secondaryProductIdList } = this.formData;
      if (productIdList) {
        data.productIdList = productIdList.split(",");
      }
      if (idList) {
        data.idList = idList.split(",");
      }
      if (secondaryProductIdList) {
        data.secondaryProductIdList = secondaryProductIdList.split(",");
      }

      queryComListDx(data).then(res => {
        this.loading = false;
        if (res.code == 200) {
          this.total = res.data.pageInfo.count;
          let arry = res.data.pageInfo.rows;
          this.tableData = arry;
          let arryAll = this.SelectedProductList
            ? this.SelectedProductList.map(v => v.collocationId)
            : [];
          let selectedIds = this.selectedIds;
          for (let i in arry) {
            if (
              arryAll.indexOf(arry[i].id) >= 0 &&
              selectedIds.indexOf(arry[i].id) == -1
            ) {
              this.$refs.multipleTable.toggleRowSelection(arry[i]);
              this.selectedIds.push(arry[i].id);
            }
          }
        }
      });
    },
    search() {
      this.formData.page = 1;
      this.getData();
    },
    selected(row, index) {
      if (this.selectedIds.indexOf(row.id) >= 0) {
        return false;
      } else {
        return true;
      }
    },
    resetForm() {
      this.selectedIds = []
      this.selectionData = []
      this.$refs["searchform"].resetFields();
      this.getData();
    },

    //修改每页数量
    handleSizeChange(val) {
      this.formData.pageSize = val;
      this.formData.page = 1;
      this.getData();
    },
    handleSelectionChange(val) {
      this.selectionData = val;
    },

    async saveData() {
      const { canMultipleChoice, goods, selectionData } = this;
      if (canMultipleChoice) {
        if (goods.length) {
          try {
            const ids = goods.map(item => item.id);
            if (ids.length > 100)
              return this.$message.error("最多添加100个商品");
            this.saveLoading = true;
            const params = await this.getSpreadActivityCollocationList(ids);
            this.saveLoading = false;
            const handleParams = params;
            this.$emit("selectProductList", handleParams);
            this.beforeclose();
          } catch (error) {
            this.saveLoading = false;
            this.$message.warning(error);
          }
        } else {
          this.$message.warning("请选择搭销商品");
        }
        return;
      }

      if (selectionData.length == 1 && !canMultipleChoice) {
        this.$emit("selectProductList", selectionData[0].id);
        this.resetForm();
      } else {
        this.$message.warning("只能选择1项商品");
      }
    },
    async getSpreadActivityCollocationList(ids) {
      try {
        const { data, code, mes } = await getSpreadActivityCollocationList(ids);
        if (code === 200) {
          return Promise.resolve(data);
        } else {
          return Promise.reject(mes);
        }
      } catch (_) {
        return Promise.reject("请求异常");
      }
    },
    //切换页面
    handleCurrentChange(val) {
      this.formData.page = val;
      this.getData();
    },
    beforeclose() {
      this.resetForm();
      this.$emit("closeShowDialog", false);
    },
    changeCascaderTwo(value) {
      // 商品分类选择
      // console.log(value, 'value')
      this.formData.categoryId = value;
    },
    changeFun(selection, row) {
      if (selection.length > 1 && !this.canMultipleChoice) {
        const del_row = selection.shift();
        this.$refs.multipleTable.toggleRowSelection(del_row, false);
      }
      this.checkList = selection[0];
    }
  }
};
</script>

<style scoped lang="less">
.coupon-clock-paging {
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/components/SelectAssemblyProductDialog.vue